import type { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";

/**
 * A figure with its label. Hierarchy comes from weight and colour rather than size alone, so a
 * row of these still has one thing that leads: pass `emphasis` to the number that matters.
 */
export function Stat({
  label,
  value,
  hint,
  emphasis = false,
  tone,
  className,
  testId,
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  emphasis?: boolean;
  tone?: "success" | "warning" | "brand";
  className?: string;
  testId?: string;
}) {
  const toneClass =
    tone === "success"
      ? "text-success"
      : tone === "warning"
        ? "text-warning"
        : tone === "brand"
          ? "text-brand"
          : "text-foreground";
  return (
    <div className={cn("space-y-1", className)} data-testid={testId}>
      <p className="text-xs font-medium tracking-wide text-muted-foreground uppercase">{label}</p>
      <p
        className={cn(
          "font-semibold num",
          emphasis ? "text-4xl tracking-tight" : "text-2xl",
          toneClass,
        )}
      >
        {value}
      </p>
      {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}
